import { AggregateRowGroup, FormattedAggregateRow } from '../types';

// Groups consecutive rows sharing a label so the label cell can span its values.
export const groupAggregateRowsByLabel = (
  rows: FormattedAggregateRow[]
): AggregateRowGroup[] => {
  const groups: AggregateRowGroup[] = [];
  rows.forEach((row) => {
    const lastGroup = groups[groups.length - 1];
    if (lastGroup && lastGroup.label === row.label) {
      lastGroup.values.push({ label: row.valueLabel, value: row.value });
      return;
    }
    groups.push({
      label: row.label,
      values: [{ label: row.valueLabel, value: row.value }],
    });
  });
  return groups;
};
